// This only works with the MonsterInsights GA plugin
$( document ).ready(function() {

  $('.cookies-notice--close').on( 'click', function (e) {

    e.preventDefault();

    var date = new Date();
    date.setTime(date.getTime() + (1000 * 60 * 60 * 24 * 7));
    $.cookie("cookies-notice-dismissed", "1", { expires: date, path: '/' });
    $('body').addClass('cookies-notice-dismissed');
    var label = $(this).text();

    if ( typeof __gaTracker !== "undefined" && label ) {

      __gaTracker('send', 'event', {
        eventCategory : 'Cookies Notice Dismissed',
        eventAction   : 'click',
        eventLabel    : label
      });

    }

  });

  if ( $('#disclaimer').length > 0 ) {

    $('.disclaimer--banner-button').on( 'click', function (e) {

      e.preventDefault();
      var label = $(this).text();

      if ( typeof __gaTracker !== "undefined" && label ) {

        __gaTracker('send', 'event', {
          eventCategory : 'Terms View Button',
          eventAction   : 'click',
          eventLabel    : label,
          transport     : 'beacon'
        });

      }

      window.location = '/disclaimer';

    });

    $('.disclaimer--terms-button').on( 'click', function (e) {

      e.preventDefault();

      var date = new Date();
      date.setTime(date.getTime() + (1000 * 60 * 60 * 24 * 7));
      $.cookie("disclaimer-accepted", "1", { expires: date, path: '/' });
      var label = $(this).text();

      if ( typeof __gaTracker !== "undefined" && label  ) {

        __gaTracker('send', 'event', {
          eventCategory : 'Terms Accept Button',
          eventAction   : 'click',
          eventLabel    : label,
          transport     : 'beacon'
        });

      }

      if ( $('body').hasClass('disclaimer-interstitial') ) {
        var redirect = getUrlParameter('redirect');
        window.location = '/' + redirect;
      } else {
        $('#disclaimer').addClass( 'disclaimer-hide' );
        $('body').removeClass('disclaimer-popup-showing');
      }

    });

  }

  $('a[href$="pdf"]').on('click', function(e) {

    var label = $(this).attr('href');

    if ( typeof __gaTracker !== "undefined" && label  ) {

      __gaTracker('send', 'event', {
        eventCategory : 'PDF Link',
        eventAction   : 'click',
        eventLabel    : label,
        transport     : 'beacon'
      });

    }

  });

  $('a:not([href$="pdf"]):not([href*="finaldomainname"]):not([href^="#"]):not([href^="/"])').on('click', function(e) {

    var label = $(this).attr('href');

    if ( typeof __gaTracker !== "undefined" && label  ) {

      __gaTracker('send', 'event', {
        eventCategory : 'Outbound Link',
        eventAction   : 'click',
        eventLabel    : label,
        transport     : 'beacon'
      });

    }

  });

});